import { createContext } from 'react';
const animationContext = createContext({
    renderThrottleMs: 0,
    subscribe() {
        return {
            startTime: 0,
            unsubscribe() { },
        };
    },
});
animationContext.displayName = 'InternalAnimationContext';
export default animationContext;
//# sourceMappingURL=AnimationContext.js.map